import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const submitEditChargerSessionData = createAsyncThunk(
  "submitEditChargerSession/fetchEditSubmitChargerSession",
  async ({ sessionId, payload }) => {
    try {
      const response = await api.post(
        `prometheus/charger-session/${sessionId}/edit/`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error Submitting Data:", error);
    }
  }
);

const SubmitEditChargerSlice = createSlice({
  name: "submitEditChargerSession",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitEditChargerSessionData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitEditChargerSessionData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(submitEditChargerSessionData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export default SubmitEditChargerSlice.reducer;
